import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countActive'
})
export class CountActivePipe implements PipeTransform {

  transform(value: any[], parameter: string): unknown {
    let count = 0;
    value.forEach(item => {
      if (item[parameter]) {
        count++;
      }
    });
    return count;
  }

}
